<template>
  <!-- 一个场景对象的组件 -->
  <div>
    <!-- 拖拽抖动的样式，最外层加一层div是为了  避免拖拽排序时的动画被 抖动的动画覆盖 -->
    <div
      :class="
        $store.state.configinfo.objectMoveState
          ? 'device_wraper_paixu_dou_dong'
          : ''
      "
    >
      <div
        class="scene_item_wraper public_control_yinying_xiaoguo"
        @click="sceneBtnClickHandle()"
        @contextmenu.prevent="sceneRightClickBtnHandle"
      >
        <div class="scene_item_img">
          <img class="scene_img" :src="OneScene.iconUrl" alt />
        </div>
        <div class="scene_item_text">
          <div class="scene_item_name">{{ OneScene.sceneName }}</div>
          <div class="scene_item_region_name">{{ OneScene.regionName }}</div>
        </div>

        <!-- 添加常用页面设备  类型显示勾选序号 -->

        <div
          v-if="viewType === 'configScene' && OneScene.followOrder != 0"
          class="scene_item_sort_index"
          :class="
            OneScene.followState === 1 ? 'scene_item_sort_index_font_big' : ''
          "
        >
          {{ OneScene.followOrder }}
        </div>
        <!-- 添加常用页面设备  类型显示勾选状态 -->
        <img
          class="config_scene_img_gouxuan"
          v-if="viewType === 'configScene'"
          v-show="OneScene.followState === 0"
          src="~assets/img/config/weixuan.png"
          alt
        />
        <img
          class="config_scene_img_gouxuan"
          v-if="viewType === 'configScene'"
          v-show="OneScene.followState === 1"
          src="~assets/img/config/xuanzhong.png"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  judgeActivePage,
  publicFadeInOut,
  jieMianStateJudge
} from 'common/tool'
import { requestSceneRule } from '../../../../network/request'
export default {
  data() {
    return {
      followOrder: ''
    }
  },
  props: {
    OneScene: Object,
    viewType: {
      type: String,
      default: ''
    }
  },
  methods: {
    sceneBtnClickHandle() {
      ////场景被点击了
      // console.log(this.OneScene.sceneName)
      if (!jieMianStateJudge()) return ///界面管理状态判断

      if (this.viewType === '') {
        this.$showControlToast('scene', this.OneScene)
      } else if (this.viewType === 'configScene') {
        if (this.OneScene.followState === 1) {
          ///取消收藏
          this.$emit('followOrderCompuder', this.OneScene.followOrder)
          this.OneScene.followState = 0
          this.OneScene.followOrder = 0
        } else {
          ///添加收藏
          this.$emit('followOrderCompuInc', this.OneScene)

          this.OneScene.followState = 1
        }
      }
    },
    sceneRightClickBtnHandle() {
      if (!jieMianStateJudge()) return ///界面管理状态判断

      // 主账号判断  0主账号
      console.log('当前是子账号不支持')
      if (sessionStorage.getItem('userType') != '0') return
      console.log('场景对象的右击事件')
      this.$showTipsToast(14, this.OneScene)
    }
  }
}
</script>

<style>
.scene_item_wraper {
  flex: 0 0 auto;

  width: 170px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  margin: 20px 50px 20px 0px;
  /* box-sizing: border-box;
    padding: 20px; */
  cursor: pointer;

  position: relative;
}
.scene_img {
  width: 100%;
  height: 100%;
}
.scene_item_img {
  height: 34px;
  width: 34px;
  display: inline-block;
  margin: 0 10px;
  flex: 0 0 auto;
  padding-left: 45px;
}
.scene_item_text {
  display: inline-block;
  margin-right: 40px;
  width: 100px;
  flex: 0 0 auto;
}
.scene_item_name {
  font-size: 16px;
  color: #282828;
}
.scene_item_region_name {
  color: #999999;
  font-size: 14px;
}

/* 打点 */
.scene_item_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scene_item_region_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 常用场景勾选用到的样式 */
.config_scene_img_gouxuan {
  height: 24px;
  width: 24px;
  display: inline-block;

  position: absolute;
  top: 30px;
  right: 5px;
}
/* 常用场景勾选排序文字样式 */
.scene_item_sort_index {
  display: inline-block;

  position: absolute;
  top: 3px;
  right: -3px;
  font-size: 16px;
  width: 40px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: var(--primary-color);
  /* font-weight: bold; */
}
</style>
